import React from 'react'
import leftarrow from "../../../assets/images/left-arrow.svg";
import { Footer } from '../../common/footer/footer';
import { useTranslation } from "react-i18next";
import styles from './otpGeneration.module.css';
import { ToastContainer } from 'react-toastify';

const OtpGenerationJsx = (props) => {
    const { t } = useTranslation();

    return (
        <>
            <section className="mainloginscreen">
                <div className="container">
                   
                        <div className={`${styles.mainloginscreeninner}`}>
                        <div className={`${styles.leftsightbackdetails} d-flex`}>
                        <div className="d-flex plaindetailsleft align-items-center justify-content-center">
                                <div className="back_btn" onClick={() => props.onBackClick()}><img src={leftarrow} alt={'icon'} /></div>
                                    <h1>{t("PASSWORDAUTHORIZATION.OTP_Generation")}</h1>
                                </div>
                            </div>
                        </div>
                        <div className={`${styles.formsection}`}>
                            <div className={`${styles.institutelogintext}`}>
                                <div className="otpgeneration forgetpassinner">
                                    <h2 className="h2_style">{t("PASSWORDAUTHORIZATION.Generating_Otp")}</h2>
                                    <h2 className="h2_style text-center pb-3">{t("PASSWORDAUTHORIZATION.Forgetpass_text")}</h2>
                                    <h5 className="text-center">{t("PASSWORDAUTHORIZATION.Reset-emailtext_one")} {props?.email}?</h5>
                                    <h5 className="text-center">{t("PASSWORDAUTHORIZATION.Reset-emailtext")}</h5>
                                   
                                    <div className="ft-inner">

                                        <div className="savestate mt-3">
                                            <button onClick={() => props.handleSubmit()} type="button" className="mt-3 mainbutton">{t("COMMON.Yes")}</button>
                                            <button type="button" className="mt-3 mainbutton borderblack">{t("COMMON.No")}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer />
                </div>
            </section>
            <ToastContainer />


        </>

    );
};

export default OtpGenerationJsx;
